import { HttpClient } from '@angular/common/http';
import { date } from './date.service';
import { tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var UserCertificationService = /** @class */ (function () {
    function UserCertificationService(http, baseUrl) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.apiUrl = this.baseUrl + "api/user/certifications";
    }
    UserCertificationService.prototype.getUserCertification = function (userCertificationId, withEmails, withSkillAreas, withAttachments) {
        if (withEmails === void 0) { withEmails = false; }
        if (withSkillAreas === void 0) { withSkillAreas = false; }
        if (withAttachments === void 0) { withAttachments = false; }
        var params = {
            withEmails: withEmails.toString(),
            withSkillAreas: withSkillAreas.toString(),
            withAttachments: withAttachments.toString()
        };
        var result = this.http
            .get(this.apiUrl + "/" + userCertificationId, {
            params: params
        })
            .pipe(tap(function (cert) { return date(cert, 'tests', 'startDate', 'endDate', 'expiryDate', 'scheduledStartTime', 'assignedUsers', 'expiryDate'); }));
        return result;
    };
    UserCertificationService.prototype.putUserCertification = function (userCertificationId, userCertificationModel) {
        return this.http.put(this.apiUrl + "/" + userCertificationId, userCertificationModel);
    };
    UserCertificationService.prototype.updateRegistrationProgress = function (userCertificationId, tabName) {
        return this.http.patch(this.apiUrl + "/" + userCertificationId + "/updateRegistrationProgress?progress=" + tabName, null);
    };
    // Admin set purchased flag.
    UserCertificationService.prototype.completeCertificationPurchase = function (userCertificationId, isPurchased) {
        return this.http.patch(this.apiUrl + "/" + userCertificationId + "/purchase", {
            isPurchased: isPurchased
        });
    };
    UserCertificationService.prototype.approveCertification = function (userCertificationId, data) {
        return this.http.patch(this.apiUrl + "/" + userCertificationId + "/score", data);
    };
    UserCertificationService.prototype.postUserCertification = function (userCertificationModel) {
        return this.http
            .post(this.apiUrl, userCertificationModel)
            .pipe(tap(function (cert) { return date(cert, 'expiryDate'); }));
    };
    UserCertificationService.prototype.getCerts = function (withEmails, withSkillAreas, withAttachments) {
        if (withEmails === void 0) { withEmails = false; }
        if (withSkillAreas === void 0) { withSkillAreas = false; }
        if (withAttachments === void 0) { withAttachments = false; }
        var params = {
            withEmails: withEmails.toString(),
            withSkillAreas: withSkillAreas.toString(),
            withAttachments: withAttachments.toString()
        };
        return this.http
            .get("" + this.apiUrl, { params: params })
            .pipe(tap(function (certs) { return date(certs, 'tests', 'expiryDate', 'completedDate', 'startDate', 'endDate', 'scheduledStartTime'); }));
    };
    UserCertificationService.prototype.getPurchasable = function () {
        return this.http.get(this.apiUrl + "/purchasable");
    };
    UserCertificationService.prototype.getPurchasableById = function (userCertification) {
        return this.http.get(this.apiUrl + "/purchasable/" + userCertification.certificationId);
    };
    UserCertificationService.ngInjectableDef = i0.defineInjectable({ factory: function UserCertificationService_Factory() { return new UserCertificationService(i0.inject(i1.HttpClient), i0.inject("BASE_URL")); }, token: UserCertificationService, providedIn: "root" });
    return UserCertificationService;
}());
export { UserCertificationService };
